import Api from './Api';

class _ContractsApi extends Api {
    constructor() {
        super();
    }

    load(id: number): Promise<any> {
        return this.getLocalHttpClient().get(`contracts/${id}`, {
            params: { include: ['project.client', 'text'] },
        });
    }
}

export const ContractsApi = new _ContractsApi();
